module.exports = __webpack_public_path__ + "static/media/add test info.02f1f7f6.svg";